class LogoScroll extends HTMLElement {
  constructor() {
    super();
    this.pauseOnHover = false;
  }

  connectedCallback() {
    this.pauseOnHover = this.dataset.pauseOnHover === 'true';

    if (this.pauseOnHover) {
      this.addEventListener('mouseenter', () => {
        this.classList.add('logo-scroll--paused');
      });
      this.addEventListener('mouseleave', () => {
        this.classList.remove('logo-scroll--paused');
      });
    }
  }
}

customElements.define('logo-scroll', LogoScroll);

